import { Dimensions } from 'react-native';

export const vw = Dimensions.get('window').width;
export const vh = Dimensions.get('window').height;
export const vmin = Math.min(vw, vh);
export const vmax = Math.max(vw, vh);

export const SIZE_FONT_BASE = vmin / 15;
export const WIDTH_SERIF_FRAME = vw * 0.9;
export const PADDING_RPG_FRAME = 15;
export const SIZE_BORDER = 3;

export const MAX_LENGTH = {
	NAME: 10,
	JOB: 9,
	SEX: 9,
};
